import { render, staticRenderFns } from "./EditorDialog.vue?vue&type=template&id=0dc8a9d6&scoped=true&"
import script from "./EditorDialog.vue?vue&type=script&lang=js&"
export * from "./EditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8a9d6",
  null
  
)

export default component.exports